<template>
  <overview-table
    title="Ingressos (Venda Online)"
    :headers="headers"
    :items="items"
    :footers="footers"
  >
    <template #[`item.type`]="{ item }">
      <span>{{ item.sector_name }} ({{ item.ticket_type_name }})</span>
    </template>
    <template #[`item.price`]="{ item }">
      <span>{{ currency(parseFloat(item.price)) }}</span>
    </template>
    <template #no-data>
      <h4>Ainda não existem vendas online para este evento.</h4>
    </template>
  </overview-table>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type Overview from '@/types/Overview'
import { currency } from '@/helpers/formatters/currency'
import { FreeTypes } from '@/constants/TicketTypeNames'
import OverviewTable, { Header } from './partials/OverviewTable.vue'

const { overview } = defineProps<{ overview: Overview }>()

// --- Items ---
const items = computed(() => {
  const items = overview.summary.filter(item => item.origin === 'venda_online' && !FreeTypes.includes(item.ticket_type_name))

  // Sum generated per batch so we can compute available = batch.quantity - total_sold_in_batch
  const sumByBatch: Record<string, number> = {}
  for (const item of items) {
    sumByBatch[item.batch_id] = (sumByBatch[item.batch_id] ?? 0) + item.generated
  }

  return items.map((item) => {
    const available = Math.max(0, (item.allowed_sales ?? 0) - sumByBatch[item.batch_id])
    return { ...item, available }
  })
})

// --- Header ---
const headers: Header[] = [
  { key: 'type' as const, value: 'type', title: 'Tipo', sortable: false },
  { key: 'batch' as const, value: 'batch', title: 'Lote', sortable: true },
  { key: 'price' as const, value: 'price', title: 'Valor Unitário', sortable: true },
  { key: 'available' as const, value: 'available', title: 'Disponíveis', sortable: true },
  { key: 'generated' as const, value: 'generated', title: 'Vendidos', sortable: true },
  { key: 'read' as const, value: 'read', title: 'Computados', sortable: true },
]

// --- Footer ---
const footers = computed(() => [
  {
    type: 'Total',
    available: items.value.reduce((acc, curr) => acc + curr.available, 0),
    generated: items.value.reduce((acc, curr) => acc + curr.generated, 0),
    read: items.value.reduce((acc, curr) => acc + curr.read, 0),
  },
  {
    type: 'Valor Total',
    generated: currency(items.value.reduce((prev, curr) => {
      return prev + (curr.generated * parseFloat(curr.price)) - parseFloat(curr.discounts)
    }, 0)),
    read: currency(items.value.reduce((prev, curr) => {
      return prev + (curr.read * parseFloat(curr.price)) - parseFloat(curr.read_discounts)
    }, 0)),
  },
])

</script>
